import {
    Stack,
    TextField,
    Typography,
    MenuItem,
    InputAdornment
} from "@mui/material";
import { User } from "../../../../types/User";

interface JobLookingForProps {
    userData: User;
    handleChange: (field: string, value: any) => void;
    editMode: boolean;
}

const JobLookingFor = ({
    userData,
    handleChange,
    editMode
}: JobLookingForProps) => {
    const jobTypes = [
        "Full-time",
        "Part-time",
        "Contract",
        "Freelance",
        "Internship",
        "Remote"
    ];

    return (
        <>
            <Typography variant="subtitle1" mb={2}>Job Looking For</Typography>

            <Stack gap={2.5}>
                {/* Job Title */}
                <Stack>
                    {editMode ? (
                        <TextField
                            fullWidth
                            size="small"
                            label="Desired Position"
                            value={userData.jobLookingFor || ""}
                            onChange={(e) => handleChange("jobLookingFor", e.target.value)}
                            placeholder="e.g. Frontend Developer"
                        />
                    ) : (
                        <Stack>
                            <Typography variant="body2" color="text.secondary">
                                Desired Position
                            </Typography>
                            <Typography variant="body1">
                                {userData.jobLookingFor || "Not specified"}
                            </Typography>
                        </Stack>
                    )}
                </Stack>

                {/* Job Type */}
                <Stack>
                    {editMode ? (
                        <TextField
                            select
                            fullWidth
                            size="small"
                            label="Job Type"
                            value={userData.jobLookingForType || ""}
                            onChange={(e) => handleChange("jobLookingForType", e.target.value)}
                        >
                            {jobTypes.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    ) : (
                        <Stack>
                            <Typography variant="body2" color="text.secondary">
                                Job Type
                            </Typography>
                            <Typography variant="body1">
                                {userData.jobLookingForType || "Not specified"}
                            </Typography>
                        </Stack>
                    )}
                </Stack>

                {/* Location */}
                <Stack>
                    {editMode ? (
                        <TextField
                            fullWidth
                            size="small"
                            label="Preferred Location"
                            value={userData.jobLookingForLocation || ""}
                            onChange={(e) => handleChange("jobLookingForLocation", e.target.value)}
                            placeholder="e.g. Remote, New York, London"
                        />
                    ) : (
                        <Stack>
                            <Typography variant="body2" color="text.secondary">
                                Preferred Location
                            </Typography>
                            <Typography variant="body1">
                                {userData.jobLookingForLocation || "Not specified"}
                            </Typography>
                        </Stack>
                    )}
                </Stack>

                {/* Salary */}
                <Stack>
                    {editMode ? (
                        <TextField
                            fullWidth
                            size="small"
                            type="number"
                            label="Expected Salary (Annual)"
                            value={userData.jobLookingForSalary || ""}
                            onChange={(e) => handleChange("jobLookingForSalary", Number(e.target.value))}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}
                            placeholder="Annual salary expectation"
                        />
                    ) : (
                        <Stack>
                            <Typography variant="body2" color="text.secondary">
                                Expected Salary (Annual)
                            </Typography>
                            <Typography variant="body1">
                                {userData.jobLookingForSalary
                                    ? `$${userData.jobLookingForSalary.toLocaleString()}`
                                    : "Not specified"}
                            </Typography>
                        </Stack>
                    )}
                </Stack>
            </Stack>
        </>
    );
};

export default JobLookingFor;

